import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  availableStatuses: null,
  registryRights: [],
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "index", name: "global:tender.index" },
      { key: "[co].name", name: "global:tender.contractor" },
      { key: "caseNumber", name: "global:tender.caseNumber" },
      { key: "[cb].lastName", name: "global:tender.createdBy" },
      { key: "status.name", name: "global:tender.status" },

    ],
    selectedSearchFields: ["index","[co].name","caseNumber","[cb].lastName","status.name"],
    dictionaryFields: [],
    url: "tender",
  },
};

const tenderReducer = createSlice({
  name: "tenderReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = tenderReducer.actions;

export default tenderReducer.reducer;
